declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_fallback_foo extends $mol_object {
		bar2( next?: number ): number
		bar1( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_fallback_foo['bar2'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_fallback_foo['bar2'] >
	}
	
}

//# sourceMappingURL=bidi_fallback.view.tree.d.ts.map